import { createSelector } from 'reselect';
import { SearchFormState } from '../reducers';
import { MIN_SEGMENTS_NUMBER } from './reducers';
import { defaultConfig } from '../../../context';

const getSegmentsState = (state: SearchFormState) => state.segments;

export const isMultiCity = createSelector(getSegmentsState, state => state.isMultiCity);

export const getSimpleRouteSegment = createSelector(getSegmentsState, state => state.simpleRouteSegment);

export const getMultiCitySegments = createSelector(getSegmentsState, state => state.multiCitySegments);

export const canAddSegment = createSelector(isMultiCity, getMultiCitySegments, (isMultiCity, segments) => {
	const maxComplexRouteSegments =
		window.__webskyEngineConfig?.SearchForm?.maxComplexRouteSegments ??
		defaultConfig.SearchForm.maxComplexRouteSegments;

	return isMultiCity && segments.length < maxComplexRouteSegments;
});

export const canRemoveSegment = createSelector(
	isMultiCity,
	getMultiCitySegments,
	(isMultiCity, segments) => isMultiCity && segments.length > MIN_SEGMENTS_NUMBER
);

export const getSegments = createSelector(
	isMultiCity,
	getSimpleRouteSegment,
	getMultiCitySegments,
	(isMultiCity, simpleRouteSegments, multiCitySegments) => (isMultiCity ? multiCitySegments : [simpleRouteSegments])
);

export const makeGetSegment = (index: number) => {
	return createSelector(getSegments, segments => segments[index]);
};

export const getSelectedDates = createSelector(
	isMultiCity,
	getSimpleRouteSegment,
	getMultiCitySegments,
	(isMultiCity, simpleRouteSegments, multiCitySegments) => {
		const result: Date[] = [];

		if (isMultiCity) {
			multiCitySegments.forEach(segment => {
				if (segment.date) {
					result.push(segment.date);
				}
			});
		} else {
			const segment = simpleRouteSegments;

			if (segment.date || segment.dateBack) {
				result.push(segment.date || null);
				result.push(segment.dateBack || null);
			}
		}

		return result;
	}
);

export const getIsSegmentsInternational = createSelector(
	getSegments,
	(_state: SearchFormState, iataCode: string) => iataCode,
	(segments, iataCode) =>
		iataCode === 'DV' &&
		segments.some(({ departure, arrival }) => {
			if (departure && arrival) {
				return departure.country?.name !== arrival.country?.name;
			}

			return false;
		})
);
